import React from "react";
import { Button } from "../../components/template";

const quizData = [
  {
    image: "/assets/knowyourself/quiz/q1.jpg",
    title: "Prakriti Quiz",
    content:
      "Discover your Mind-Body Type with this simple quiz to make smarter choices for a balanced and healthier life.",
    link: "/wellness-quiz/know-your-prakriti",
  },
  {
    image: "/assets/knowyourself/quiz/q2.jpg",
    title: "Holistic Wellness Test",
    content:
      "Find out the best nutrition plan for your body type and improve your health naturally.",
    link: "/wellness-quiz/holistic-wellness-test",
  },
  {
    image: "/assets/knowyourself/quiz/q3.jpg",
    title: "Body Tox Level Quiz",
    content:
      "Identify the right workout and wellness plan that fits your lifestyle and goals.",
    link: "/wellness-quiz/body-toxin-level",
  },
  {
    image: "/assets/knowyourself/quiz/q11.jpeg",
    title: "Guna Proportion Self-Assessment",
    content:
      "Understand the balance of Sattva, Rajas, and Tamas shaping your thoughts, energy, and daily patterns.",
    link: "/wellness-quiz/guna-self-assessment",
  },
  {
    image: "/assets/knowyourself/quiz/q9.jpeg",
    title: "Emotional Wellbeing Assessment",
    content:
      "Reflect on how you process emotions, handle stress, and support your inner emotional health.",
    link: "/wellness-quiz/emotional-wellbeing",
  },
  {
    image: "/assets/knowyourself/quiz/q8.jpeg",
    title: "Gut Health Self-Assessment",
    content:
      "Notice digestion, energy, and eating patterns to understand how your gut supports your wellbeing.",
    link: "/wellness-quiz/gut-health",
  },
  {
    image: "/assets/knowyourself/quiz/q10.jpeg",
    title: "Self-Love Self-Assessment",
    content:
      "Explore how kindly you treat yourself through rest, boundaries, self-talk, and daily care.",
    link: "/wellness-quiz/self-love",
  },
    {
    image: "/assets/knowyourself/quiz/q7.jpeg",
    title: "Integrity Self-Assessment",
    content:
      "Notice how aligned your values, words, and actions feel in everyday situations — especially when it’s uncomfortable.",
    link: "/wellness-quiz/integrity",
  },
  {
    image: "/assets/knowyourself/quiz/q5.jpeg",
    title: "Nutrition & Healthy Eating",
    content:
      "Check your understanding of digestion, meal timing, food quality, and common nutrition myths.",
    link: "/wellness-quiz/nutrition-knowledge",
  },
  {
    image: "/assets/knowyourself/quiz/q4.jpeg",
    title: "Sleep, Stress & Body Awareness",
    content:
      "Understand how sleep timing, stress, routines, and daily habits influence your energy and overall balance.",
    link: "/wellness-quiz/sleep-stress-awareness",
  },

];



const QuizCard = ({ item }) => (
  <div className="bg-white shadow-md rounded-md overflow-hidden md:flex items-stretch">
    
    {/* Image Wrapper */}
    <div className="md:w-1/3 w-full h-48 md:h-56 flex-shrink-0">
      <img
        src={item.image}
        alt={item.title}
        className="w-full h-full object-cover"
      />
    </div>

    {/* Content */}
    <div className="p-5 md:w-2/3 flex flex-col justify-between">
      <div className="space-y-3">
        <h2 className="text-xl font-bold text-primary">
          {item.title}
        </h2>
        <p className="text-gray-700">
          {item.content}
        </p>
      </div>

      <div className="mt-4">
        <Button
          text="Take the Quiz"
          variant="primary"
          size="sm"
          link={item.link}
          className="inline-block"
        />
      </div>
    </div>

  </div>
);


const QuizSection = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 py-8 space-y-6">
      <h3 className="text-xl md:text-4xl font-extrabold text-center text-[#578d48] md:mb-12 mt-4 md:mt-8 mb-8">Know more about yourself through these fun quizzes</h3>
      {quizData.map((item, index) => (
        <QuizCard key={index} item={item} />
      ))}
    </div>
  );
};

export default QuizSection;
